import React from "react";
import { appLogger } from "../../utils";
import Filter from "./filter";

const FeedbackContent = (props: any) => {
  appLogger.info({ infoObj: { method: "FeedbackContent", component: "feedback", fileName: "index.tsx", props: props } });
  const { pageType, stateValue } = props;
  return <Filter pageType={pageType} stateValue={stateValue} />;
};

export default FeedbackContent;
